import { Component, OnInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { HistoryService } from '../../service/history.service';
import { HistoryEntry } from '../../model/HistoryEntry';
import { Exam } from '../../model/Exam';
import {
	ActivatedRoute,
	NavigationEnd,
	Router,
	RouterOutlet,
} from '@angular/router';
import { KeyValue } from '../../model/KeyValue';
import { Admission } from '../../model/Admission';
import { Document } from '../../model/Document';
import { Location } from '@angular/common';
import { Course } from '../../model/Course';


export interface Step {
  label: string;
	description: string;
}

export class Condition {
  label: string = '';
	subconditions: string = '';
  position: number | null = null
}

export enum Conditions {
  LANGUAGE = 'Competenze linguistiche',
  DEGREE= 'Voto di Laurea',
  EXAMS=  'Percorso di studi pregresso',
}

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
	admission: Admission = new Admission();
	course!: string;
	school!: string;
	courseTypes: Array<KeyValue> = [];
	schools: Array<KeyValue> = [];
    documents: Array<Document> = [];
    dipartimenti: Array<KeyValue> = [];
	dipartimento: KeyValue = new KeyValue();
	contactEmail: string = '';
	chat!: boolean;
	question!: string;
	answer!: string;
	asking: boolean = false;
	showTemplate: boolean = false;
	showTrace: boolean = false;
	template: string = '';
	trace!: string;
	reasons!: any;
	reason!: string;
	admission_id!: string;
	short_id!: string;
	prompt!: string;
	failurePattern: Array<string> = ['RISPOSTA FINALE (SI/NO): No', 'No '];
	successPattern: Array<string> = ['RISPOSTA FINALE (SI/NO): Si', 'Si '];
	ssds: Array<KeyValue> = [];
	languageLevels: Array<KeyValue> = [];
	savingMessage: string | null = null;
	documentParseOk: boolean | null = null;

	degreeTypes: Array<KeyValue> = [];
	degree_votes: Array<KeyValue> = [];
	selectedFile: File | null = null;
	documentProcessing = false;
	currentStep: number = 2;
	insertMode: string = 'upload';

	manualMode: string = 'manual';
	uploadMode: string = 'upload';

  conditionsOrder: Array<string> = [
    Conditions.DEGREE,
    Conditions.EXAMS,
    Conditions.LANGUAGE
  ]

	public applicationError: boolean = false;
	public askError: boolean = false;

	public files: File[] = [];

  // public examsAverage: number | null = null
  public examVotes: number[] = [18,19,20,21,22,23,24,25,26,27,28,29,30]

  public voteOptions: Array<{key: string, value: string}> = [
    { key: '18', value: '18' },
    { key: '19', value: '19' },
    { key: '20', value: '20' },
    { key: '21', value: '21' },
    { key: '22', value: '22' },
    { key: '23', value: '23' },
    { key: '24', value: '24' },
    { key: '25', value: '25' },
    { key: '26', value: '26' },
    { key: '27', value: '27' },
    { key: '28', value: '28' },
    { key: '29', value: '29' },
    { key: '30', value: '30' },
    { key: '30L', value: '30 e Lode' }
  ];

	constructor(
		private _mainService: MainService,
		private _historyService: HistoryService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private _location: Location
	) {
		activatedRoute.queryParams.subscribe((params) => {
			this.currentStep = params['step'] ? parseInt(params['step']) : 2;
      if(params['restoreFrom']) {
        this.restoreFromHistory(params['restoreFrom']);
        return;
      }
      if(this.currentStep === 4 && !this.askDisabled() && !this.answer) {
        this.ask();
      }
		});
	}

	/**
	 * On init
	 */
	ngOnInit() {
		this.getSSD();
		const idAdmission = this.activatedRoute.snapshot.params['id_admission'];
		if (idAdmission) {
			this._mainService.getAdmission(idAdmission).subscribe((admission) => {
				if (admission) {
					this.admission = admission;
				}
			});
		}
		const restoreFrom = this.activatedRoute.snapshot.queryParamMap.get('restoreFrom');
		if (restoreFrom) {
			return;
		}
		const initialStep = this._historyService.list().length > 0 ? 1 : 2;
		this.router.navigate(['/'], { queryParams: { step: initialStep } });
	}

	stepInError(step: number) {
		let isInError = false;
		switch (step) {
			case 2:
				// isInError = !this.admission.degree_type || !this.admission.exam_vote;
				isInError = false;
				break;
			case 3:
				isInError = !this.course;
				break;
			case 4:
				isInError = this.answer.trim() !== '' && this.isFailure();
				break;
		}

		return isInError;
	}

	steps() {
		return [
			// {
			// 	label: 'Modalità',
			// 	description: this.isUpload()
			// 		? 'Dichiarazione sostitutiva'
			// 		: 'Inserimento manuale',
			// },
			{
				label: 'Modalità',
				description: 'Inserimento manuale',
			},
			// {
			// 	label: 'Laurea ed Esami',
			// 	description: this.isUpload()
			// 		? 'Controllo Dati estratti'
			// 		: 'Inserimento dati',
			// },
			{
				label: 'Laurea ed Esami',
				description: 'Inserimento dati',
			},
			{
				label: 'Scelta Corso',
				description: this.course
					? this.getCourseByKey(this.course)
					: 'Selezione Corso',
			},
			{
				label: 'Esito',
				description: this.answer
					? this.isFailure()
						? 'Non idoneo'
						: 'Idoneo'
					: '-',
			},
		];
	}

	getCourseByKey(courseKey: string) {
		return this.courseTypes.filter(
			(course: any) => course['key'] === courseKey
		)[0]['value'];
	}

	degreeNameByKey(degreeKey: string) {
		return this.degreeTypes.filter(
			(degree: any) => degree['key'] === degreeKey
		)[0]['value'];
	}

  isLanguage(condition: Condition){
    return condition.label === Conditions.LANGUAGE
  }

  allAlternativesFailed(condition: Condition){
    let somePassed = false;
    Object.values(condition.subconditions).forEach((subcondition: any) => {
      subcondition['message'].forEach((subsubcondition: any) => {
        if(subsubcondition.passed){
          somePassed = true;
        }
      });
    });
    return !somePassed;
  }

	isUpload() {
		return this.insertMode === 'upload';
	}

	isManual() {
		return this.insertMode === 'manual';
	}

	setInsertMode(mode: string) {
		this.insertMode = mode;
	}

	onValueChange(file: File[]) {
		this.files = file;
		this.selectedFile = file[0];
		this.onFileSubmit();
	}

	cleanFile() {
		this.files = [];
		this.documentParseOk = null;
		this.selectedFile = null;
	}

	goNextStep() {
		if (this.currentStep === 1) {
			this.startNew();
			return;
		}
		this.currentStep++;
		this.router.navigate(['/'], { queryParams: { step: this.currentStep } });
	}

	nextStepDisabled() {
		return (
			(this.currentStep === 3 && !this.course)
		);
	}

	resetAnswer() {
		this.answer = '';
	}

	goPreviousStep() {
		this.currentStep--;
		this._location.back();
	}

  askDisabled(){
    return this.asking || this.course==null || this.course==='' || this.school==null || this.school===''
  }

	previousStepDisabled() {
		return this.currentStep <= 2;
	}

	isChat() {
		return false;
	}

	isAdmission() {
		return true;
	}

	getAskType() {
		return false ? 'chat' : 'admission';
	}

	changeAskType() {
		// this.getTemplate();
		// this.answer = '';
	}

	filteredCourseTypes() {
		return this.courseTypes.filter(
			(course: any) => course['school'] === this.school
		);
	}

	schoolByKey(key: string) {
		return this.schools.filter((school: any) => school['key'] === key)[0][
			'value'
		];
	}

	isPsychologySchool(): boolean {
		return this.schoolLabel().includes('psicologia');
	}

	private schoolLabel(): string {
		if (!this.school || !this.schools || this.schools.length === 0) {
			return '';
		}
		const match = this.schools.filter((school: any) => school['key'] === this.school);
		if (match.length === 0) {
			return '';
		}
		return (match[0]['value'] || '').toLowerCase();
	}

	private courseLabel(): string {
		if (!this.course || !this.courseTypes || this.courseTypes.length === 0) {
			return '';
		}
		const match = this.courseTypes.filter((course: any) => course['key'] === this.course);
		if (match.length === 0) {
			return '';
		}
		return (match[0]['value'] || '').toLowerCase();
	}

	// Contatti da mostrare nel disclaimer, come da richiesta UniPD del 15/05
	disclaimerContact(): string {
		const economiaCourses = [
			'accounting finance and business consulting',
			'applied economics',
			'management and sustainable firms',
		];
		const course = this.courseLabel();
		if (economiaCourses.some((name) => course.includes(name))) {
			return 'orientamento.economia@unipd.it; didattica.economia@unipd.it';
		}
		const school = this.schoolLabel();
		if (school.includes('psicologia')) {
			return 'tutorjunior.psicologia@unipd.it';
		}
		if (school.includes('ingegneria')) {
			return 'ingegneria@unipd.it';
		}
		// esclude "Scienze umane..." e "Economia e Scienze politiche"
		if (school.includes('scienze') && !school.includes('umane') && !school.includes('politiche')) {
			return 'scienze@unipd.it';
		}
		return '';
	}

	courseByKey(key: string) {
		return this.courseTypes.filter((course: any) => course['key'] === key)[0][
			'value'
		];
	}

	courseFatherByKey(key: string) {
		return this.courseTypes.filter((course: any) => course['key'] === key)[0][
			'father'
		];
	}
	dipartimentiById(id: String) {
		return this.dipartimenti.filter((dipartimento: any) =>dipartimento['id'] === id)[0];
	}


	getSSD() {
		// this._mainService.getSSD().subscribe((result) => {
		this._mainService.getSSDWithDetails().subscribe({
			next: (result) => {
				if (result) {
					this.ssds = result.ssd;
					this.degreeTypes = result.degree;
					this.languageLevels = result.language;
					this.degree_votes = result.degree_vote;
					this.courseTypes = result.course;
					this.schools = result.school;
					this.dipartimenti = result.dipartimenti;
          this.documents = result.documents;
				}
			},
			error: (e) => {
				this.applicationError = true;
				console.log(e);
			},
		});
	}

	prePopulateDescription(ssd: any, index: number) {
		this.admission.exams[index].description = ssd.value;
		this.resetAnswer();
	}

	ask(): void {
		this.asking = true;
		this.answer = '';
		this.askError = false;
		this.dipartimento = this.dipartimentiById(this.courseFatherByKey(this.course));
		const selectedCourse = this.courseTypes.filter((c: any) => c['key'] === this.course)[0];
		this.contactEmail = selectedCourse?.email || this.dipartimento.email;
		this._mainService.askExams(this.course, this.admission).subscribe({
			next: (answer) => {
				this.asking = false;
				this.answer = answer.answer;
				this.trace = answer.trace;
				this.reason = answer.reason;
				this.admission_id = answer.admission_id;
				this.short_id = answer.short_id;
				// console.log(this.answer);

        let conditions: Array<Condition> = [];
        Object.values(answer.errors).forEach((condition: string, index: number) => {
          let cnd: Condition = new Condition();
          cnd.subconditions = condition;
          cnd.label = Object.keys(answer.errors)[index];
          cnd.position = !isNaN(this.conditionsOrder.indexOf(cnd.label)) ? this.conditionsOrder.indexOf(cnd.label) : 99;
          conditions.push(cnd);
        });
				this.reasons = conditions.sort((a: any,b: any) => a.position - b.position);

				this.saveToHistory();
			},
			error: (e) => {
				this.asking = false;
				this.askError = true;
				console.error('Server Error:', e);
			},
		});
		// console.log(this.answer);
	}

	private saveToHistory() {
		try {
			this._historyService.save({
				course: this.course,
				courseLabel: String(this.getCourseByKey(this.course)),
				school: this.school,
				schoolLabel: String(this.schoolByKey(this.school)),
				admission: this.admission,
				answer: this.answer,
				trace: this.trace,
				reason: this.reason,
				errors: this.reasons,
				admission_id: this.admission_id,
				short_id: this.short_id,
				outcome: this.isFailure() ? 'non_idoneo' : 'idoneo',
			});
		} catch (e) {
			console.warn('History save failed', e);
		}
	}

	recentHistory(): HistoryEntry[] {
		return this._historyService.list();
	}

	restoreFromHistory(entryId: string) {
		const entry = this._historyService.getById(entryId);
		if (!entry) {
			this.router.navigate(['/'], { queryParams: { step: 2 } });
			return;
		}
		this.school = entry.school;
		this.course = entry.course;
		this.admission = entry.admission;
		this.answer = entry.answer;
		this.trace = entry.trace;
		this.reason = entry.reason;
		this.reasons = entry.errors;
		this.admission_id = entry.admission_id;
		this.short_id = entry.short_id;
		this.dipartimento = this.dipartimentiById(this.courseFatherByKey(this.course)) || this.dipartimento;
		const selectedCourse = this.courseTypes.filter((c: any) => c['key'] === this.course)[0];
		this.contactEmail = selectedCourse?.email || (this.dipartimento && this.dipartimento.email) || '';
		this.router.navigate(['/'], { queryParams: { step: 2 }, replaceUrl: true })
			.then(() => this.router.navigate(['/'], { queryParams: { step: 3 } }))
			.then(() => this.router.navigate(['/'], { queryParams: { step: 4 } }));
	}

	startNew() {
		this.admission = new Admission();
		this.course = '' as any;
		this.school = '' as any;
		this.answer = '';
		this.trace = '' as any;
		this.reason = '' as any;
		this.reasons = null;
		this.admission_id = '' as any;
		this.short_id = '' as any;
		this.askError = false;
		this.router.navigate(['/'], { queryParams: { step: 2 } });
	}

	clearHistory() {
		this._historyService.clear();
	}

	deleteHistoryEntry(id: string) {
		this._historyService.delete(id);
	}

	askWithPrompt() {
		this.asking = true;
		this.answer = '';
		this.askError = false;
		this._mainService.askWithPrompt(this.prompt).subscribe({
			next: (answer) => {
				this.asking = false;
				this.answer = answer.answer;
				this.trace = answer.trace;
				this.reason = answer.reason;
			},
			error: (e) => {
				this.asking = false;
				this.askError = true;
				console.error('Prompt error:', e);
			},
		});
	}

	getObjectValues(object: object) {
		return Object.values(object);
	}

  getObjectKeys(object: object) {
		return Object.keys(object);
	}

	capitalizedCourse(course: any) {
		var splitStr = course.toLowerCase().split(' ');
		for (var i = 0; i < splitStr.length; i++) {
			// You do not need to check if i is larger than splitStr length, as your for does that for you
			// Assign it back to the array
			splitStr[i] =
				splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
		}
		// Directly return the joined string
		return splitStr.join(' ');
	}

	toggleTemplate() {
		this.showTemplate = !this.showTemplate;
	}

	toggleTrace() {
		this.showTrace = !this.showTrace;
	}

	addExam(): void {
		const exam = new Exam();
		this.admission.exams.push(exam);
	}

	removeExam(i: number): void {
		const newExams: Exam[] = [];
		for (var j = 0; j < this.admission.exams.length; j++) {
			if (i != j) {
				newExams.push(this.admission.exams[j]);
			}
		}
		this.admission.exams = newExams;
	}

	isFailure() {
		return this.answer === 'NO';
	}

	isSuccess() {
		return this.answer === 'YES';
	}

	onFileChange(event: Event) {
		const files = (event.target as HTMLInputElement).files;
		if (files && files.length > 0) {
			this.selectedFile = files[0];
		}
		this.onFileSubmit();
	}

	onFileSubmit() {
		if (this.selectedFile) {
			this.documentProcessing = true;
			// Send the file using an HTTP service or other methods
			const formData = new FormData();
			formData.append('file', this.selectedFile);
			// ... send formData using your preferred HTTP service
			this._mainService.digestExamsDocument(this.selectedFile).subscribe({
				next: (digestedExams) => {
					this.documentParseOk = true;
					this.admission.name = digestedExams['name'];
					this.admission.cf = digestedExams['cf'];
					this.admission.degree_type = digestedExams['degree_type'];
					this.admission.exam_vote = digestedExams['degree_vote'];
					this.admission.languageLevel = digestedExams['english_exam_code'];
					this.admission.new_file_name = digestedExams['new_file_name'];
					this.admission.exams = [];
					if (digestedExams['exams']) {
						for (var examDigestedIndex in digestedExams['exams']) {
							const examDigested = digestedExams['exams'][examDigestedIndex];
							const exam = new Exam();
							exam.cfu = Number(examDigested['cfu']);
							exam.description = examDigested['desc'];
							exam.ssd = examDigested['cod'];
							this.admission.exams.push(exam);
						}
					}
					this.documentProcessing = false;
					setTimeout(() => {
						this.currentStep = 2;
					}, 2000);
				},
				error: (e) => {
					this.documentParseOk = false;
					this.documentProcessing = false;
				},
			});
		}
	}

	save() {
		this.savingMessage = 'Saving...';
		this._mainService.saveAdmission(this.admission).subscribe({
			next: (admission) => {
				if (admission) {
					this.savingMessage = 'Done!';
					this.admission = admission;
					setTimeout(() => {
						this.savingMessage = null;
					}, 1000);
				}
			},
			error: (e) => {
				this.savingMessage = 'Errore durante il salvataggio, riprova.';
				console.error('Save error:', e);
				setTimeout(() => {
					this.savingMessage = null;
				}, 3000);
			},
		});
	}

  documentUrl(){
    let course: any = this.courseTypes.filter(
			(course: any) => course.key === this.course
		)[0];

    let document = this.documents.filter(
			(document: Document) => document.id === course.document
		)[0];

    //return document ? (document.value + '/' + document.key) : null;
	return "https://www.unipd.it/avvisi-ammissione-lauree-magistrali";
  }

  onlyPositiveNumbers(examIndex: number) {
    if(this.admission.exams[examIndex].cfu !== null && !isNaN(this.admission.exams[examIndex].cfu)){
      this.admission.exams[examIndex].cfu = Math.abs(this.admission.exams[examIndex].cfu)
    }
  }

  setVoteFromLabel(examIndex: number) {
    const label = this.admission.exams[examIndex].voteLabel;
    if (label === '30L') {
      this.admission.exams[examIndex].vote = 30;
    } else if (label) {
      this.admission.exams[examIndex].vote = parseInt(label, 10);
    } else {
      this.admission.exams[examIndex].vote = null;
    }
    this.recomputeExamsAverage();
  }

  recomputeExamsAverage() {
    const eligible = this.admission.exams.filter(
      e => e.vote != null && e.cfu != null && !isNaN(Number(e.cfu)) && Number(e.cfu) > 0
    );
    if (eligible.length === 0) return;
    const totalCfu = eligible.reduce((s, e) => s + Number(e.cfu), 0);
    const weighted = eligible.reduce((s, e) => s + Number(e.vote) * Number(e.cfu), 0);
    this.admission.examsAverage = Math.floor(weighted / totalCfu);
  }
}
